var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "mdc-snackbar",
        attrs: {
          "aria-live": "assertive",
          "aria-atomic": "true",
          "aria-hidden": "true"
        }
      },
      [
        _c("div", { staticClass: "mdc-snackbar__text" }),
        _vm._v(" "),
        _c("div", { staticClass: "mdc-snackbar__action-wrapper" }, [
          _c("button", {
            staticClass: "mdc-snackbar__action-button",
            attrs: { type: "button" }
          })
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-573c0296", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-573c0296","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Snackbar.vue
// module id = Bz0m
// module chunks = 1